import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import ItemForm from './ItemForm';
// import { initialValues  } from './initialValues-testing';
import { showItemApi, updateItemApi, clearEditedItem } from './itemSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function ItemUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.item);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'items');
        dispatch(updateItemApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showItemApi({ navigate, id }));

        return () => dispatch(clearEditedItem());
    }, []);

    return (
        <ItemForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ItemUpdate;
